var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeAttachedPsvModalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 58,
    height: 58,
    rx: 29,
    fill: "#D5E6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14068_45763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6758 38.8495L28.0011 40.9717C24.3351 43.0885 19.6454 41.8319 17.5274 38.1637C15.4117 34.4966 16.6684 29.808 20.3344 27.6911L24.0101 25.5689L25.6297 28.3736L21.9539 30.497C19.8414 31.7157 19.1134 34.4305 20.3344 36.543C21.5542 38.6588 24.2679 39.3868 26.3815 38.1626L30.0562 36.0436L31.6758 38.8495ZM28.1939 19.8337L26.0717 23.5084L28.8764 25.1301L30.9987 21.4544C32.2185 19.3419 34.9323 18.6139 37.0448 19.8348C39.1594 21.0557 39.8874 23.7662 38.6687 25.882L36.5454 29.5566L39.3501 31.1751L41.4734 27.5015C43.5881 23.8323 42.3314 19.1447 38.6676 17.029C34.9984 14.911 30.3086 16.1677 28.1939 19.8337ZM36.2084 41.7355L34.3408 41.9998L33.7742 38.0045L35.6397 37.7412L36.2084 41.7355ZM42.5004 33.8445L42.2307 35.7121L38.2354 35.1412L38.5029 33.2757L42.5004 33.8445ZM36.2897 37.1085L37.6211 35.776L40.4789 38.6317L39.1454 39.9642L36.2897 37.1085Z",
    fill: "#2F80ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14068_45763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(16.5 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeAttachedPsvModalIcon);
export default __webpack_public_path__ + "static/media/de-attached-psv-modal-icon.6f0a73e5a9f32b239b85c3be1f92819e.svg";
export { ForwardRef as ReactComponent };